import * as React from 'react';
import { Route } from 'react-router-dom';
import { clubSchema } from './club';
import Main from '@app/main/tables/Main';
import { mandatSchema } from '../Mandat/mandat';

/**
 * Routes configurées pour le module Club
 */
const ClubRoutes = [
    // Route de liste (principale)
    <Route
        key="clubs-list"
        path="clubs"
        element={<Main key="clubs-main" pageConfig={clubSchema} />}
    />,

    // Route pour afficher les mandats d'un club
    <Route
        key="clubs-mandat"
        path="clubs/:id/mandats"
        element={<Main key="mandat-from-club" pageConfig={mandatSchema} />}
    />,
];

export default ClubRoutes;
